import React from "react";
import { useNotify, usePermissions, useRedirect, useTranslate } from "react-admin";

import { MultiChangesStateEnum } from "../../../components/GridForm";
import { CompanyManagerEmployeeRoles, OSFCUserRoles } from "../../../entities";
import { OrderService } from "../../../entities";
import { isNullUndEmpty } from "../../../utils/general";
import { MultipleOrderEditByCustomer, MultipleOrderEditByOSFC } from "./EditForms";

function getSameValue(arr) {
	if (arr.length) {
		let sameVal = arr[0];
		if (isNullUndEmpty(sameVal)) {
			for (let ind = 1; ind < arr.length; ind++) {
				if (!isNullUndEmpty(arr[ind])) return;
			}
		} else {
			for (let ind = 1; ind < arr.length; ind++) {
				if (arr[ind] !== sameVal) return;
			}
		}
		return sameVal;
	}
}

export const MultiEditPage = ({ selectedIds, recordsByIds, ...props }) => {
	const [recordData, seRecordData] = React.useState();
	const { permissions } = usePermissions();
	const redirect = useRedirect();
	const notify = useNotify();
	const translate = useTranslate();

	React.useEffect(() => {
		const records = Object.values(recordsByIds);
		if (records.length) {
			const keys = [];
			const values = {};
			const multiValues = {};
			const multiInfo = {};
			const state = {};

			for (const [key, val] of Object.entries(records[0])) {
				keys.push(key);
				multiValues[key] = [val];
			}
			for (let ind = 1; ind < records.length; ind++) {
				for (const key of keys) {
					multiValues[key].push(records[ind][key]);
				}
			}

			for (const key of keys) {
				const sameVal = getSameValue(multiValues[key]);
				if (sameVal === undefined) {
					values[key] = null;
					state[key] = MultiChangesStateEnum.IS_INIT_DIFF | MultiChangesStateEnum.IS_CALC;
				} else {
					values[key] = sameVal;
					state[key] = MultiChangesStateEnum.NONE;
				}

				multiInfo[key] = multiValues[key].map((x) => (isNullUndEmpty(x) ? "EMPTY" : x)).join(", ");
			}

			seRecordData({
				values,
				initialValues: { ...values },
				multiValues,
				multiInfo,
				state,
			});
		}
	}, [recordsByIds]);

	if (!recordData) return null;
	if (!permissions) return null;

	if (recordData?.multiValues?.service) {
		const services = recordData.multiValues.service;
		const uniqueServices = [...new Set(services)];

		const hasColdStorageService = uniqueServices.includes(OrderService.coldStorage);
		const hasOtherServices = uniqueServices.some(
			(serviceId) => serviceId !== OrderService.coldStorage && serviceId !== null
		);

		if (hasColdStorageService && hasOtherServices) {
			redirect("/");
			notify(
				translate("osfc.messages.validation.multiEditWithColdStorageAndOtherService"),
				"error"
			);
		}
	}

	const isOSFCUser = permissions && OSFCUserRoles.has(permissions.role);
	const isCustomerManagerEmployee = CompanyManagerEmployeeRoles.indexOf(permissions.role) !== -1;

	if (isOSFCUser) {
		return (
			<MultipleOrderEditByOSFC
				{...props}
				selectedIds={selectedIds}
				record={recordData.values}
				initRecordData={recordData}
			/>
		);
	} else if (isCustomerManagerEmployee) {
		return (
			<MultipleOrderEditByCustomer
				{...props}
				selectedIds={selectedIds}
				record={recordData.values}
				initRecordData={recordData}
			/>
		);
	}

	return null;
};
